import { forOwn } from 'lodash';
import { parse, serialize } from 'cookie';

export const EXPIRY_TIME = 5;
export const EXPIRY_FOREVER = 'Fri, 31 Dec 9999 23:59:59 GMT';

export const extractHostname = (options = {}) => {
  const { delimiter = '.', deep = 2 } = options;
  const { hostname } = window.location;
  const parts = hostname.split(delimiter);
  return parts.slice(-deep).join(delimiter);
};


const set = (data, expires) => {
  const date = new Date();
  date.setMinutes(date.getMinutes() + EXPIRY_TIME);
  forOwn(data, (value, key) => {
    document.cookie = serialize(key, value, {
      expires: expires || date,
      domain: extractHostname(),
    });
  });
};

const setForever = data => set(data, new Date(EXPIRY_FOREVER));

const get = (key) => {
  const cookie = document.cookie ? parse(document.cookie) : {};
  return cookie[key] || null;
};

export default {
  get,
  set,
  setForever,
};



// WEBPACK FOOTER //
// ./src/helpers/cookie.js